import { Fade, Stack, styled } from '@mui/material'
import clsx from 'clsx'
import { memo, ReactNode, useEffect, useRef, useState } from 'react'
import { OrderModeDetail } from 'store/spot/types'
import { IconArrowDown } from '../Icons'
import { ZKTab } from 'components/ZKTab'

const Wrap = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  position: relative;
`
const LeftSlot = styled(Stack)`
  flex-direction: row;
  gap: 16px;
  color: ${(props) => props.theme.color.text40};
  line-height: 18px;
  font-weight: 600;
  font-size: 14px;
`
const ModeItem = styled(Stack)`
  flex-direction: row;
  align-items: center;
  padding: 4px 0;
  position: relative;
  z-index: 1;
  cursor: pointer;
  user-select: none;
  font-weight: normal;

  &.active {
    color: ${(props) => props.theme.color.text100};
  }
  &.active {
    border-bottom: 2px solid ${(props) => props.theme.color.text100};
  }
`

const ExpandedModes = styled(Stack)`
  flex-direction: row;
  gap: 16px;
`
const StyledDropdownModes = styled(ExpandedModes)`
  position: relative;
`
const CurrentDropdownMode = styled(ModeItem)``
const TriggerPopup = styled(Stack)`
  justify-content: center;
  padding: 0 4px;
  margin-right: -4px;
  height: 100%;
`
const Popup = styled(Stack)`
  position: absolute;
  top: 110%;
  right: 0;
  padding: 2px 0;
  background-color: ${({ theme }) => theme.color.text10};
  border-radius: 4px;
  z-index: 2;
`
const PopupOption = styled(Stack)`
  padding: 2px 8px;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  line-height: 1.4;
  text-align: center;
  white-space: nowrap;

  &:hover {
    background-color: ${({ theme }) => theme.color.bg};
  }
  &.active {
    font-weight: 600;
    color: ${({ theme }) => theme.palette.primary.main};
    cursor: default;
  }
`

export const PlaceOrderModeSelection = memo<{
  modeDetails: OrderModeDetail[]
  currentMode: OrderModeDetail
  onHandleType: (orderType: OrderModeDetail) => void
  rightSlot?: ReactNode
}>(({ modeDetails, currentMode, onHandleType, rightSlot = null }) => {
  const expandedModes = modeDetails
    .filter((item) => !item.dropdown)
    .map((d) => {
      return {
        ...d,
        value: d.orderType,
        label: d.name,
      }
    })

  return (
    <Wrap>
      <LeftSlot>
        <ExpandedModes id="zk_order_mode">
          <ZKTab
            wrapStyle={{ gap: '10px' }}
            tabs={expandedModes}
            // @ts-ignore
            tabClick={(row) => onHandleType(row)}
            activeValue={currentMode.name}
            activeKey={'label'}
            itemStyle={{
              paddingBottom: '3px',
              fontSize: '14px',
              fontWeight: 400,
            }}
          ></ZKTab>
          {/* {expandedModes.map((mode) => {
            const classNames = clsx({ active: currentMode.name === mode.name })
            return (
              <ModeItem
                key={mode.name}
                className={classNames}
                onClick={() => onHandleType(mode)}
              >
                {mode.name}
              </ModeItem>
            )
          })} */}
        </ExpandedModes>
        <DropdownModes
          modeDetails={modeDetails}
          currentMode={currentMode}
          onHandleType={onHandleType}
        />
      </LeftSlot>

      {rightSlot}
    </Wrap>
  )
})

export const DropdownModes = memo<{
  modeDetails: OrderModeDetail[]
  currentMode: OrderModeDetail
  onHandleType: (orderType: OrderModeDetail) => void
}>(({ modeDetails, currentMode, onHandleType }) => {
  const dropdownModes = modeDetails.filter((item) => item.dropdown)

  const [currentDropdownMode, setCurrentDropdownMode] =
    useState<OrderModeDetail>(dropdownModes[0])
  const [visible, setVisible] = useState<boolean>(false)

  const leaveTimer = useRef<any>(null)
  useEffect(() => {
    return () => clearTimeout(leaveTimer.current)
  }, [])

  useEffect(() => {
    if (currentMode.dropdown) {
      setCurrentDropdownMode(currentMode)
    }
  }, [currentMode])

  if (!dropdownModes.length) {
    return null
  }

  return (
    <StyledDropdownModes>
      <CurrentDropdownMode
        className={clsx({
          active: dropdownModes.map((v) => v.name).includes(currentMode.name),
        })}
        onClick={() => {
          onHandleType(currentDropdownMode)
        }}
      >
        {currentDropdownMode?.name}
        <TriggerPopup
          onMouseOver={() => {
            setVisible(true)
          }}
          onMouseLeave={() => {
            leaveTimer.current = setTimeout(() => {
              setVisible(false)
            }, 100)
          }}
        >
          <IconArrowDown />
        </TriggerPopup>
      </CurrentDropdownMode>
      <Fade in={visible} timeout={0}>
        <Popup
          onMouseOver={() => {
            setVisible(true)
            clearTimeout(leaveTimer.current)
          }}
          onMouseLeave={() => setVisible(false)}
        >
          {dropdownModes.map((mode) => {
            return (
              <PopupOption
                key={mode.name}
                className={clsx({
                  active: currentMode.name === mode.name,
                })}
                onClick={() => {
                  onHandleType(mode)
                  setVisible(false)
                }}
              >
                {mode.name}
              </PopupOption>
            )
          })}
        </Popup>
      </Fade>
    </StyledDropdownModes>
  )
})
